import { transformPromptDtoToModel } from '../prompt/mappers';
import { hiddenCategoryIds } from '../../../data/categories';
import { SearchResponse, SearchResponseDto } from './types';

export const transformPromptsDtoToCards = (response: SearchResponseDto): SearchResponse => {
    // Фильтруем промпты, исключая те, что содержат скрытые категории
    const filteredResponse = response.filter(prompt => {
        // Проверяем, что промпт не содержит скрытых категорий
        return !prompt.categories.some(category => hiddenCategoryIds.includes(category));
    });

    return filteredResponse.map(transformPromptDtoToModel);
};
